import styled, { css } from 'styled-components'

const iconType = ({ type }) => {
  if (type === 'confirmed') {
    return css`
      background-color: rgba(5, 148, 79, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(5, 148, 79, 1);
      }
    `
  } else if (type === 'rejected') {
    return css`
      background-color: rgba(225, 25, 0, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `
  }
}

export const EcosystemHeaderNavbarWrapper = styled.div`
  width: 100%;
  border-top: 1px solid rgba(32, 32, 32, 0.2);
  border-bottom: ${(p) => {
    return p.bottomBorder ? '1px solid rgba(32, 32, 32, 0.2)' : 'none'
  }};
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(p) => {
    return p.isOpen ? '48px' : '0px'
  }};
`

export const EcosystemHeaderNavbarHalfSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const EcosystemHeaderIconWrapper = styled.div`
  height: 16px;
  width: 16px;
  display: grid;
  place-items: center;
`

export const EcosystemHeaderIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : '#0aa1f4'
  }};
`

export const EcosystemHeaderTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  height: 16px;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 16px;
  max-width: ${(p) => {
    return p.isReassess ? '493px' : '630px'
  }};
  text-overflow: ellipsis;
  color: ${(p) => {
    return p.isRejected ? 'rgba(32, 32, 32, 0.5)' : 'rgba(32, 32, 32, 1)'
  }};
`

export const EcosystemHeaderNavbarIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;
  margin-left: 16px;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const EcosystemHeaderSubText = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-right: 8px;
  color: ${(p) => {
    return p.active ? '#0AA1F4' : 'rgba(32, 32, 32, 0.7)'
  }};

  :hover {
    color: #0AA1F4;
  }
`

export const EcosystemHeaderNavbarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 12px;
`

export const RemoveItemModalText = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`

export const RemoveItemModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button:first-of-type {
    margin-right: 16px;
  }
`

export const EcoSystemValidationIcon = styled.div`
  position: absolute;
`

export const EcosystemValidationIconWrapper = styled.div`
  position: relative;
  left: 16px;
`

export const EcosystemConfirmDeclineIcon = styled.div`
  margin-right: 24px;
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  ${iconType}
`

export const EcosystemsCancelIconWrapper = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  user-select: none;
  cursor: pointer;
  margin-left: 16px;

  :hover {
    background: rgba(225, 25, 0, 0.05);

    path {
      fill-opacity: 1;
      fill: rgba(225, 25, 0, 1);
    }
  }
`

export const EcosystemCalendarIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  margin-right: 8px;
`

export const EcosystemCalendarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 24px;
`

export const EcosystemCalendarDateText = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-bottom: 1px dotted rgba(32, 32, 32, 0.5);

`

export const EcosystemLastReassessmentCalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EcosystemContentFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 64px;
`

export const EcosystemActionMenuWrapper = styled.div`
  margin-left: 8px;
`

export const EcosystemToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const EcosystemListTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 32px;
  color: rgba(32, 32, 32, 0.7);
  border-bottom: 1px dotted rgba(32, 32, 32, 0.7);
  margin-top: ${(p) => {
    return p.marginTop
  }};
`
export const EcosystemListTitleWrapper = styled.div`
  margin-top: ${(p) => {
    return p.addMarginTop ? '64px' : '0'
  }};
  width: 100%;
  display: flex;
  justify-content: center;
`

